import { Component } from 'react';
import { connect } from 'react-redux';

import { Badge, Button, Pane } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import DataTable from '../../common/DataTable/DataTable';
import { getEventReservations } from '../actions/EventReservationActions';

const STATUS_COLORS = {
    waiting: 'blue',
    done: 'green',
    cancelled: 'red'
};

const STATUS_LABELS = {
    waiting: 'In asteptare',
    done: 'Finalizata',
    cancelled: 'Anulata'
};

const PAYMENT_STATUS_COLORS = {
    unpaid: 'yellow',
    paid: 'green',
    refunded: 'orange'
};

const PAYMENT_STATUS_LABELS = {
    unpaid: 'Neplatit',
    paid: 'Platit',
    refunded: 'Rambursat'
};

class ListEventReservations extends Component {
    constructor(props) {
        super(props);
    }

    handleTableChange = (opts) => {
        this.props.dispatch(getEventReservations(opts));
    }

    renderStatus = (row) => {
        return <>
            <Badge color={STATUS_COLORS[row.status] || 'neutral'}>{STATUS_LABELS[row.status] || row.status}</Badge>
            {row.waitlisted ? <Badge color="yellow" marginLeft={4}>Lista de asteptare</Badge> : null}
        </>;
    }

    renderPaymentStatus = (paymentStatus) => {
        return <Badge color={PAYMENT_STATUS_COLORS[paymentStatus] || 'neutral'}>{PAYMENT_STATUS_LABELS[paymentStatus] || paymentStatus}</Badge>;
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16} gap={16} alignItems="flex-end" flexWrap="wrap">
                <Pane>
                    <Link to="/event-reservations/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Rezervare noua
                        </Button>
                    </Link>
                </Pane>
            </Pane>

            <DataTable
                defaultFilter='createdAt'
                defaultDirection='desc'
                columns={[
                    { id: 'id', label: 'Id' },
                    { id: 'confirmationCode', label: 'Cod Confirmare' },
                    { id: 'name', label: 'Nume' },
                    { id: 'email', label: 'Email' },
                    { id: 'phone', label: 'Telefon' },
                    { id: 'event.title', label: 'Eveniment', accessor: (row) => row.event?.title || '-' },
                    { id: 'status', label: 'Status', accessor: (row) => this.renderStatus(row) },
                    { id: 'paymentStatus', label: 'Plata', accessor: (row) => this.renderPaymentStatus(row.paymentStatus) },
                    { id: 'amount', label: 'Suma', accessor: (row) => row.amount ? `${row.amount} RON` : '-' },
                    { id: 'createdAt', label: 'Data', decorator: 'date' }
                ]}

                data={this.props.data}

                onTableChange={this.handleTableChange}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}

                itemMenu={[
                    { getLink: (item) => `/event-reservations/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/event-reservations/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return {
        ...state.eventReservations
    };
}

export default connect(mapStateToProps)(ListEventReservations);
